import { createAsyncThunk, createSlice, isAsyncThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { IntegrationStateClass } from "./interfaces/IntegrationStateClass";
import { Await } from "react-router-dom";
// interface IntegrationItem {
//     value: string;
//     label: string;
//   }
const initialState: IntegrationStateClass = {
  isLoading: false,
  //LocationList: [],
  status: "idle",
  selectedRecord: {},
  isReload: false,
  app:"",
  value:"",
  IntegrationList: [],
  GoogleCalendarItems: []
};

interface IThunkApi {
  state: {
    integration: IntegrationStateClass
  }
};

export const getStateAsync = createAsyncThunk
  <any, void, IThunkApi>
  (
    "Integrations/V2/getState",
    async (arg, thunkApi) => {
      const response = await fetchAPI('api/V2/Integrations/GetState', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      const json = await response.json();
      return json;
    }
  )
export const XeroAsync = createAsyncThunk
  <any, any, IThunkApi>
  (
    "Integrations/V2/Xero",
    async (arg, thunkApi) => {
      const { code, scope, callbackstate, session_state } = arg;
      //console.log('arg:','Handler/Integration/Xero.ashx?code='+code+'&scope='+scope+'&state='+callbackstate+'&session_state='+session_state+'');
      //const response = await fetchAPI('api/V2/Integrations/Xero?code='+code+'&scope='+scope+'&state='+callbackstate+'&session_state='+session_state+'', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      const response = await fetchAPI('api/V2/Integrations/Xero/' + code + '/' + callbackstate, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      ///const response = await fetchAPI('api/V2/Logs/GetWebhookReceiverLogDatatable/' + currentPage + '/' + pageSize + '/' + start + '/' + order + '/' + (orderDir === undefined ? '' : orderDir)  + '/' + SearchParamsValues + '/' + search, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      const json = await response.json();
      return json;
    }
  )
export const QBAsync = createAsyncThunk
  <any, any, IThunkApi>
  (
    "Integrations/V2/QB",
    async (arg, thunkApi) => {
      const { code, scope, callbackstate, session_state } = arg;
      // console.log('arg:','Handler/Integration/QB.ashx?code='+code+'&scope='+scope+'&state='+callbackstate+'&session_state='+session_state+'');
      //const response = await fetchAPI('api/V2/Integrations/Xero?code='+code+'&scope='+scope+'&state='+callbackstate+'&session_state='+session_state+'', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      const response = await fetchAPI('api/V2/Integrations/QB/' + code + '/' + callbackstate, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      ///const response = await fetchAPI('api/V2/Logs/GetWebhookReceiverLogDatatable/' + currentPage + '/' + pageSize + '/' + start + '/' + order + '/' + (orderDir === undefined ? '' : orderDir)  + '/' + SearchParamsValues + '/' + search, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
      const json = await response.json();
      return json;
    }
  )

  export const sendToGoogleCalendarAsync = createAsyncThunk
  <any, any, IThunkApi>
  (
    "Integrations/V2/sendToGoogleCalendar",
    async (arg, thunkApi) => {
      const { commaSeparatedIds, exportType, timeZoneId } = arg;
      const requestBody = [{
        commaSeparatedIds: commaSeparatedIds
    }];
      const response = await fetchAPI(`api/V2/Integrations/SendToGoogleCalendar/${exportType}/${timeZoneId}`, 'POST', requestBody, true);
      const json = await response.json();
      return json;
    }
  )


  export const sendToOutlookCalendarAsync = createAsyncThunk
  <any, any, IThunkApi>
  (
    "Integrations/V2/SendToOutlookCalendar",
    async (arg, thunkApi) => {
      const { commaSeparatedIds, exportType, timeZoneId } = arg;
      const requestBody = [{
        commaSeparatedIds: commaSeparatedIds
    }];
      const response = await fetchAPI(`api/V2/Integrations/SendToOutlookCalendar/${exportType}/${timeZoneId}`, 'POST', requestBody, true);
      const json = await response.json();
      return json;
    }
  )



export const integrationSlice = createSlice({
  name: 'integration',
  initialState,
  reducers: {
    resetSelectedRecordObjectInState: (state) => {
      // state.selectedRecord = {};
    },
    setXeroFromLocalStorage: (state, action) => {
      state.app = "Xero";
      state.value = action.payload;
      const payloadApp: any = { value: action.payload, label: "Xero" };

      const existingItemIndex = state.IntegrationList.findIndex(
        (item: any) => item.label === payloadApp.label
      );

      if (existingItemIndex !== -1) {
        state.IntegrationList = state.IntegrationList.map((item, index) =>
          index === existingItemIndex ? payloadApp : item
        );
      } else {
        state.IntegrationList = [...state.IntegrationList, payloadApp];
      }
      state.selectedRecord = {};
    },
    setXero: (state, action) => {
      const { appFromUrl, valueFromUrl } = action.payload;
      state.app = appFromUrl;
      state.value = valueFromUrl;
      const payloadApp: any = { value: valueFromUrl, label: appFromUrl };

      const existingItemIndex = state.IntegrationList.findIndex(
        (item: any) => item.label === payloadApp.label
      );

      if (existingItemIndex !== -1) {
        state.IntegrationList = state.IntegrationList.map((item, index) =>
          index === existingItemIndex ? payloadApp : item
        );
      } else {
        state.IntegrationList = [...state.IntegrationList, payloadApp];
      }
      localStorage.setItem('Xero', JSON.stringify(payloadApp.value));
      state.selectedRecord = {};
    },
    setQB: (state, action) => {
      const { appFromUrl, valueFromUrl } = action.payload;
      state.app = appFromUrl;
      state.value = valueFromUrl;
      const payloadApp: any = { value: valueFromUrl, label: appFromUrl };

      const existingItemIndex = state.IntegrationList.findIndex(
        (item: any) => item.label === payloadApp.label
      );

      if (existingItemIndex !== -1) {
        state.IntegrationList = state.IntegrationList.map((item, index) =>
          index === existingItemIndex ? payloadApp : item
        );
      } else {
        state.IntegrationList = [...state.IntegrationList, payloadApp];
      }
      localStorage.setItem('QB', JSON.stringify(payloadApp.value));
      state.selectedRecord = {};
    },
    setQBFromLocalStorage: (state, action) => {
      // const {id_token,expires_in,token_type,refresh_token,scope,expire_time,tenants} = action.payload;
      state.app = "QB";
      state.value = action.payload;
      const payloadApp: any = { value: action.payload, label: "QB" };

      const existingItemIndex = state.IntegrationList.findIndex(
        (item: any) => item.label === payloadApp.label
      );

      if (existingItemIndex !== -1) {
        state.IntegrationList = state.IntegrationList.map((item, index) =>
          index === existingItemIndex ? payloadApp : item
        );
      } else {
        state.IntegrationList = [...state.IntegrationList, payloadApp];
      }
      state.selectedRecord = {};
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getStateAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
      })
      .addCase(getStateAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = false;
        state.isLoading = false;
      })
      .addCase(getStateAsync.rejected, (state) => {
        state.status = 'failed';
        state.isLoading = false;

      })

      .addCase(XeroAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
      })
      .addCase(XeroAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = false;
        state.isLoading = false;
        state.app = payload.app;
        state.value = payload.value;
        const payloadApp: any = { value: payload.value, label: payload.app };

        const existingItemIndex = state.IntegrationList.findIndex(
          (item: any) => item.label === payloadApp.label
        );

        if (existingItemIndex !== -1) {
          // If it exists, update it

          state.IntegrationList = state.IntegrationList.map((item, index) =>
            index === existingItemIndex ? payloadApp : item
          );
        } else {
          // If it doesn't exist, add it to the array

          state.IntegrationList = [...state.IntegrationList, payloadApp];
        }
        localStorage.setItem('Xero', JSON.stringify(payload.value));
        state.selectedRecord = {};
        // console.log(payloadApp,existingItemIndex,state.IntegrationList);
      })
      .addCase(XeroAsync.rejected, (state) => {
        state.status = 'failed';
        state.isLoading = false;

      })

      .addCase(QBAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
      })
      .addCase(QBAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = false;
        state.isLoading = false;
        state.app = payload.app;
        state.value = payload.value;
        const payloadApp: any = { value: payload.value, label: payload.app };

        const existingItemIndex = state.IntegrationList.findIndex(
          (item: any) => item.label === payloadApp.label
        );

        if (existingItemIndex !== -1) {
          // If it exists, update it

          state.IntegrationList = state.IntegrationList.map((item, index) =>
            index === existingItemIndex ? payloadApp : item
          );
        } else {
          // If it doesn't exist, add it to the array

          state.IntegrationList = [...state.IntegrationList, payloadApp];
        }

        //console.log(payloadApp,existingItemIndex,state.IntegrationList);
      })
      .addCase(QBAsync.rejected, (state) => {
        state.status = 'failed';
        state.isLoading = false;
      })


      .addCase(sendToGoogleCalendarAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
      })
      
      .addCase(sendToGoogleCalendarAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = false;
        state.isLoading = false;
        
      })
      .addCase(sendToGoogleCalendarAsync.rejected, (state) => {
        state.status = 'failed';
        state.isLoading = false;
      })

      .addCase(sendToOutlookCalendarAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
      })
      
      .addCase(sendToOutlookCalendarAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = false;
        state.isLoading = false;
        
      })
      .addCase(sendToOutlookCalendarAsync.rejected, (state) => {
        state.status = 'failed';
        state.isLoading = false;
      })

  }

});

export const { resetSelectedRecordObjectInState, setXeroFromLocalStorage, setXero, setQBFromLocalStorage, setQB } = integrationSlice.actions
export const integrationState = (state: RootState) => state.integration
export default integrationSlice.reducer
